/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Forgot_Error_GenericInputs */

const es_co2_password_forgot_error_generic = /** @type {(inputs: Password_Forgot_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos procesar la solicitud. Intenta de nuevo.`)
};

/**

* @param {Password_Forgot_Error_GenericInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const password_forgot_error_generic = /** @type {((inputs?: Password_Forgot_Error_GenericInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Forgot_Error_GenericInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_password_forgot_error_generic(inputs)
});